export default [
    'answered',
    'approved',
    'begun',
    'clicked',
    'completed',
    'created',
    'deleted',
    'loaded',
    'rejected',
    'revisited',
    'updated',
    'viewed',
];
